import { clientApi, API_ENDPOINTS } from "../index";

export type ApiResponse = {
  ok: string;
  message: string;
};

export const resetPassword = async (
  email: string,
  emailCode: string,
  newPassword: string
): Promise<ApiResponse> => {
  try {
    const data = await clientApi.post<ApiResponse>(`${API_ENDPOINTS.AUTH.RESET_PASSWORD}`, {
      email,
      code: emailCode,
      new_password: newPassword,
    });

    return data;
  } catch (error) {
    // 원본 에러가 detail을 포함하고 있으면 그대로 전달
    if (error instanceof Error) {
      const originalError = error as Error & {
        detail?: { title: string; message: string };
      };
      const newError = new Error(error.message) as Error & {
        detail?: { title: string; message: string };
      };
      if (originalError.detail) {
        newError.detail = originalError.detail;
      }
      throw newError;
    }
    throw error;
  }
};
